import React, { useState } from 'react';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';
import dayjs from 'dayjs';
import { useDispatch } from 'react-redux';
import { listTechFiles } from '../../../modules/projectModule/techFiles';
import TechPlanForm from '../../../components/projectmng/support/TechPlanForm';
import * as techApi from '../../../lib/api/tech';
import * as fileApi from '../../../lib/api/file';
import { setTechPlan } from '../../../modules/projectModule/techPlan';

const TechPlanAddFormContainer = ({ project, tech, reloadTech, user }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const [initialValues, setInitialValues] = useState({
    plnTitle: project?.cstNm,
    plnTyp: '',
    plnStrtDt: '',
    plnEndDt: '',
    plnContext: '',
    files: [{ file: null, fileDesc: '' }]
  });

  const validationSchema = yup.object({
    plnTitle: yup.string('').required('작업 계획 제목을 입력하세요'),
    plnTyp: yup.string().required('작업 계획 종류를 선택하세요'),
    plnStrtDt: yup
      .date()
      .required('작업 계획 시작일을 입력하세요')
      .nullable()
      .default(undefined),
    plnEndDt: yup
      .date()
      .required('작업 계획 종료일을 입력하세요')
      .min(yup.ref('plnStrtDt'), '작업 계획 종료일을 확인하세요')
      .when('plnStrtDt', (plnStrtDt, schema) => {
        if (plnStrtDt) return schema.required('작업 계획 종료일을 입력하세요');
      })
      .nullable()
      .default(undefined),
    plnContext: yup.string('').required('작업 계획 사항을 입력하세요'),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);
      onSave(values);
      setSubmitting(false);
    },
  });

  const onFileSave = async (value, tech) => {
    let formData = new FormData();
    formData.append('fileDt', value.file);
    formData.append('fileTyp', 'tech');
    formData.append('fileAttrVal1', tech.reqUuid);
    formData.append('fileAttrVal2', tech.prjUuid);
    formData.append('fileAttrVal3', '기술 지원 예정');
    formData.append('fileDesc', value.fileDesc);

    try {
      const response = await fileApi.addFiles(formData);

      if (response.data.result === 'success') {
        enqueueSnackbar("첨부파일 업로드 성공", {
          variant: 'success',
        });
      }

    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  const onSave = async (values) => {
    let dataToSubmit = {
      reqUuid: tech.reqUuid,
      prjUuid: tech.prjUuid,
      plnTitle: values.plnTitle,
      plnTyp: values.plnTyp,
      plnStrtDt: (values.plnStrtDt) ? dayjs(values.plnStrtDt).format('YYYY-MM-DD') : null,
      plnEndDt: (values.plnEndDt) ? dayjs(values.plnEndDt).format('YYYY-MM-DD') : null,
      plnContext: values.plnContext,
      plnUsr: user.usrUuid,
    };

    try {
      const res = await techApi.addTechPlan(dataToSubmit);

      if (res.data.info) {
        if (values.files.length > 0 && values.files[0].file != null) {
          values.files.forEach(value => {
            onFileSave(value, tech);
          })
        };

        reloadTech(tech.reqUuid);
        dispatch(setTechPlan(res.data.info))
        dispatch(listTechFiles('tech', tech.reqUuid));
      }
      enqueueSnackbar('저장 성공', {
        variant: 'success',
      });
    } catch (err) {

      let message =
        err.response !== 'undefined' ? err.response?.data?.message : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };



  return (
    <TechPlanForm formik={formik} />
  )
}

export default TechPlanAddFormContainer